// Generated by scripts/build-ui-icons.mjs.
export { UsersThree as default } from "../ui/glyphs-8";
